/**
 * Tiny local cn — no clsx / tailwind-merge dep. Joins truthy strings
 * with a space. The package can stay framework-light since the host
 * app already pulls @ordo/ui (which provides the styled primitives).
 */

type Falsy = false | 0 | '' | null | undefined

export function cn(...args: Array<string | Falsy>): string {
  return args.filter((a): a is string => typeof a === 'string' && a.length > 0).join(' ')
}
